import CalibriMedium from 'assets/fonts/Calibre-Medium.ttf';
import CalibriRegular from 'assets/fonts/Calibre-Regular.ttf';
import CalibriSemiBold from 'assets/fonts/Calibre-Semibold.ttf';
import { FONTS } from 'common/constants';
import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
// @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap');

@font-face {
    font-family: ${FONTS.regular};
    src: url(${CalibriRegular}) format('truetype');
}

@font-face {
    font-family: ${FONTS.medium};
    src: url(${CalibriMedium}) format('truetype');
}

@font-face {
    font-family: ${FONTS.semiBold};
    src: url(${CalibriSemiBold}) format('truetype');
}

/* UNIVERSAL */
    * {
        box-sizing: border-box;
    }

    html,
    body {
        background-color: #fff;
        font-family: ${FONTS.regular}, sans-serif;
        line-height: 1.5;
        height: 100%;
        width: 100%;
        overflow-x: hidden;
        margin: 0;
        padding: 0;
        left: 0;
        top: 0;
        font-size: 100%;
        color: ${({ theme }) => theme.colors.bodyText};
        scroll-behavior: smooth;
        scrollbar-width: 9px;
        scrollbar-color: #e7e7e7;
        
        *::-webkit-scrollbar {
            width: 9px;
            background: #e7e7e7;
        }
        *::-webkit-scrollbar-track {
            background: transparent;
        }
        *::-webkit-scrollbar-thumb {
            background-color: #e1e1e1;
            box-shadow: inset 0px 0px 2px rgba(0, 0, 0, 0.3);
            border-radius: 10px;
        }
    }
`;

export const BaseImagePointContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;

  & > img {
    width: 100%;
    height: 100vh;
  }
`;

export const ShowSmallScreenMsg = styled.div`
  display: none;

  @media (max-width: 1023px) {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    padding: 1rem 3rem;
    flex-direction: column;
  }
`;

export const SmallScreenHeading = styled.h1`
  //   font-size: 1.5rem;
  display: block;
`;

export const ShowAllComponents = styled.div`
  display: none;

  @media (min-width: 1024px) {
    display: block;
  }
`;
